import React from "react";
import { menu } from "./userGuideMenuData";
import MenuItem from "./MenuItem";

export default function UserGuideMenu() {
  return (
    <div className=" bg-white sticky top-1 z-10">
      <div className="pl-4 absolute -top-9 pt-3">
        <span className="text-[12px] font-semibold  text-[#68737D] tracking-[0.5px] uppercase">Table of Contents</span>
      </div>
      {menu.map((item, index) => {
        return <MenuItem key={index} title={item.title} item={item} level={item.id.split("-").length} />;
      })}
    </div>
  );
}
